import React from "react";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";
import { Entity } from "@radivision/graphql/lib/ts/graphql/entity";
import $ from "jquery";
import { connect } from "react-redux";
import { AppState, store } from "../../../redux";
import * as Actions from "../../../redux/actions";
import { SVG } from "../../../component-configuration/svgs";
import { PostsPanel } from "./posts";
import { AboutPanel } from "./about";
import { InvestmentPanel } from "./investment";
import { MarketplacePanel } from "./marketplace";
// import { PeoplePortfolioTab, CompaniesPortfolioTab, PeoplePortfolioPanel, CompaniesPortfolioPanel } from "./portfolio";
import { SetProfileActiveTabPayload, SetProfileActiveTabAction } from "../../../redux/account/types";
import { GridIcon, AboutIcon } from "./icons";
import { OffersTab } from "./marketplace/offers-tab";
import { HorizontalScroller } from "../../page-framework/horizontal-scroller";
import { setAppState, startVideoPlayer, stopVideoPlayer } from "../../../redux/actions";
import { FetchStoryItemPayload, FetchStoryItemAction } from "../../../redux/cache/types";
import {
  StartVideoPlayerAction,
  StopVideoPlayerAction,
  PipPlayerPayload,
  PipPlayerState,
} from "../../../redux/youtube-player/types";

interface DetailsTabProps {
  entity?: Entity;
  isCompany: boolean;
  isPerson: boolean;
  isSpectator: boolean;
  isOwner: boolean;
  person?: Person;
  updateUser?: Function;
}
interface DetailsTabState {
  activeTabIndex: number;
  scrollableTabs: boolean;
}

interface MapStateProps {
  profileActiveTab: string | null;
  item: Story;
}

interface MapDispatchProps {
  setProfileActiveTab: (payload: SetProfileActiveTabPayload) => SetProfileActiveTabAction;
  fetchStoryItem: (payload: FetchStoryItemPayload) => FetchStoryItemAction;
  startVideoPlayer: (payload: PipPlayerPayload) => StartVideoPlayerAction;
  stopVideoPlayer: () => StopVideoPlayerAction;
}

type Props = DetailsTabProps & MapStateProps & MapDispatchProps;
class Component extends React.Component<Props, DetailsTabState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      activeTabIndex: 0,
    };

    this.setActiveTab = this.setActiveTab.bind(this);
    this.activateTab = this.activateTab.bind(this);
    this.fetchItem = this.fetchItem.bind(this);
  }

  componentDidMount() {
    this.activateTab();
  }
  componentDidUpdate() {
    this.activateTab();
    this.fetchItem();
  }
  fetchItem() {
    const { item, entity, fetchStoryItem } = this.props;
    const id = entity?.pitchOriginalMedia?.id;
    fetchStoryItem({ id });
  }

  activateTab() {
    let activeTab = null;

    const hashActiveTab = window.location.hash.replace("#", "");
    const profileActiveTab = this.props.profileActiveTab;
    if (["About", "Opportunities", "Links", "Portfolio", "People", "Marketplace"].includes(hashActiveTab)) {
      activeTab = hashActiveTab;
    } else if (profileActiveTab) {
      activeTab = profileActiveTab;
    }

    if (activeTab) {
      this.setActiveTab(activeTab);
    }
  }

  setActiveTab(activeTab: string) {
    const profileActiveTab = this.props.profileActiveTab;
    if (profileActiveTab === "Opportunities" && activeTab !== "Opportunities") {
      store.dispatch(startVideoPlayer(this.props.item?.originalClip?.externalId));
    }
    if (profileActiveTab !== "Opportunities" && activeTab === "Opportunities") {
      store.dispatch(stopVideoPlayer());
    }
    $(`a[href="#${activeTab}"]`).tab("show");
    if (window.location.hash !== `#${activeTab}` && !(this.props.isPerson && activeTab === "Opportunities")) {
      window.location.hash = activeTab;
      store.dispatch(setAppState({ currentHash: activeTab }));
    }
    // document.body.scrollTop = 0;
    // document.documentElement.scrollTop = 0;
    if (profileActiveTab !== activeTab) {
      this.props.setProfileActiveTab({ activeTab });
    }
  }

  render(): React.ReactNode {
    return (
      <div>
        <HorizontalScroller rootClassName="tabs" extraClassName="nav nav-tabs nav-justified">
          {this.props.entity || this.props.isPerson ? (
            <li className="nav-item ">
              <a
                className="nav-link active my-media"
                data-toggle="tab"
                href="#Posts"
                onClick={() => ((window.location.hash = "Posts"), this.setActiveTab("Posts"))}
              >
                <GridIcon />
                <span>Posts</span>
              </a>
            </li>
          ) : null}

          {this.props.isCompany && this.props.entity && (
            <li className="nav-item nav-opportunities-tab">
              <a
                className="nav-link opportunities"
                href="#Opportunities"
                data-toggle="tab"
                onClick={() => this.setActiveTab("Opportunities")}
              >
                {SVG.bulb}
                <span style={{ position: "relative" }}>Pitch Planet</span>
              </a>
            </li>
          )}

          {this.props.entity && (
            <li className="nav-item nav-overview-tab">
              <a
                className="nav-link overview"
                data-toggle="tab"
                href="#About"
                onClick={() => this.setActiveTab("About")}
              >
                <AboutIcon />
                <span>About</span>
              </a>
            </li>
          )}

          {this.props.person && (
            <li className="nav-item dna-tab">
              <a className="nav-link dna" data-toggle="tab" onClick={() => this.setActiveTab("About")} href="#About">
                <AboutIcon />
                <span>About</span>
              </a>
            </li>
          )}
          {/* <CompaniesPortfolioTab entity={this.props.entity} />
          <PeoplePortfolioTab entity={this.props.entity} /> */}
          {/* <OffersTab entity={this.props.entity} /> */}
          {/* {this.props.isCompany && this.props.entity && (
              <li className="nav-item nav-marketplace-tab">
                <a
                  className="nav-link marketplace"
                  href="#Marketplace"
                  data-toggle="tab"
                  onClick={() => this.setActiveTab("Marketplace")}
                >
                  <MarketIcon />
                  <span>Offers</span>
                </a>
              </li>
            )} */}
        </HorizontalScroller>
        <div className="tab-content">
          <PostsPanel subject={this.props.entity || this.props.person} />
          <AboutPanel subject={this.props.person || this.props.entity} />
          {/* <CompaniesPortfolioPanel entity={this.props.entity} />
          <PeoplePortfolioPanel entity={this.props.entity} /> */}
          <InvestmentPanel entity={this.props.entity} />
          {/* <MarketplacePanel entity={this.props.entity} /> */}
        </div>
      </div>
    );
  }
}

const mapState = (state: AppState, props: DetailsTabProps) => ({
  profileActiveTab: state.account.profileActiveTab,
  item: state.cache.store && state.cache.store[props.entity?.pitchOriginalMedia?.id],
});

const mapDispatch = {
  setProfileActiveTab: Actions.setProfileActiveTab,
  fetchStoryItem: Actions.fetchStoryItem,
  startVideoPlayer: startVideoPlayer,
  stopVideoPlayer: stopVideoPlayer,
};

export const DetailsTab = connect(mapState, mapDispatch)(Component);
